import React from 'react';

interface FractionProps {
  numerator: React.ReactNode;
  denominator: React.ReactNode;
  className?: string;
}

const Fraction: React.FC<FractionProps> = ( { numerator, denominator, className } ) => {
  return (
    <span className={`inline-flex flex-col items-center align-middle ${className ?? ''}`}>
      <span className="text-sm leading-tight break-words text-center">{numerator}</span>
      <span className="w-full border-t border-gray-400 my-1" style={{ width: '100%' }} aria-hidden />
      <span className="text-sm leading-tight break-words text-center">{denominator}</span>
    </span>
  );
};

export default Fraction;
